import { useEffect as e, useMemo as t, useState as n } from "react";
import { twMerge as r } from "tailwind-merge";
import { InputGroup as i, Select as a } from "@systemeio/components";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { ChevronDownIcon as c } from "@systemeio/icons";
//#region src/components/url-input.tsx
var l = "https://", u = {
	"https://": "example.com",
	"mailto:": "contact@example.com",
	"tel:": "+15551234567"
}, d = (e, t) => t.find((t) => e.startsWith(t.value))?.value, f = (e) => e[0]?.value ?? l, p = (e, t) => {
	let n = d(e, t);
	return n ? e.slice(n.length) : e;
}, m = "focus-visible:focus-ring-primary border-field-border bg-field-bg-secondary transition-base hover:bg-bg-tertiary disabled:bg-field-bg-disabled disabled:text-text-disabled flex h-8 items-center gap-2.5 rounded-l-md border border-r-0 px-3 text-base outline-none data-popup-open:[&_svg]:rotate-180";
function h({ className: h, disabled: g, label: _, onChange: v, placeholder: y, schemeOptions: b, value: x }) {
	let S = t(() => b ?? [{
		label: l,
		value: l
	}], [b]), [C, w] = n(d(x, S) ?? f(S));
	e(() => {
		let e = d(x, S);
		e && e !== C && w(e);
	}, [
		S,
		C,
		x
	]);
	let T = (e) => {
		let t = e.target.value;
		if (!t) return v("");
		let n = d(t, S);
		n && w(n), v((n ?? C) + p(t, S));
	}, E = (e) => {
		w(e);
		let t = p(x, S);
		v(t ? e + t : "");
	}, D = S.find((e) => e.value === C), O = S.length > 1 ? /* @__PURE__ */ s(a.Root, {
		disabled: g,
		drawerTitle: _,
		items: S,
		onValueChange: (e) => E(e),
		value: C,
		children: [/* @__PURE__ */ s(a.Trigger, {
			render: /* @__PURE__ */ o("button", {
				className: m,
				disabled: g,
				type: "button"
			}),
			unstyled: !0,
			children: [D?.label ?? C, /* @__PURE__ */ o(c, { className: "text-icon-primary transition-base size-5" })]
		}), /* @__PURE__ */ o(a.Content, { children: /* @__PURE__ */ o(a.List, { children: S.map((e) => /* @__PURE__ */ o(a.Option, {
			value: e.value,
			children: e.customLabel ?? e.label
		}, e.value)) }) })]
	}) : null, k = /* @__PURE__ */ s(i.Root, {
		size: "sm",
		children: [O ? null : /* @__PURE__ */ o(i.Addon, {
			align: "inline-start",
			appearance: "filled",
			children: /* @__PURE__ */ o(i.Text, { children: D?.label ?? C })
		}), /* @__PURE__ */ o(i.Input, {
			disabled: g,
			inputMode: "url",
			onChange: T,
			placeholder: y ?? u[C],
			type: "text",
			value: p(x, S)
		})]
	}), A = O ? /* @__PURE__ */ s("div", {
		className: r("flex items-end", "[&_[data-slot=input-group]]:rounded-l-none [&_input]:rounded-l-none", h),
		children: [O, k]
	}) : /* @__PURE__ */ o("div", {
		className: h,
		children: k
	});
	return _ ? /* @__PURE__ */ s("label", {
		className: "flex min-w-0 flex-col gap-1 text-sm",
		children: [/* @__PURE__ */ o("span", {
			className: "text-text-primary",
			children: _
		}), A]
	}) : A;
}
//#endregion
export { h as UrlInput };
